import { CircularProgress, Dialog, DialogContent, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProcessingModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ProcessingModal: React.FC<ProcessingModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen} onClose={onClose} PaperProps={{ sx: { p: 4, textAlign: 'center', borderRadius: 2 } }}>
      <DialogContent>
        <CircularProgress size={60} sx={{ mb: 3 }} />
        <Typography variant="h6">{t('ocrDataInput.processingImage', 'Processing your image')}</Typography>
        <Typography variant="body2" color="text.secondary">
            {t('ocrDataInput.processingImageHint', 'This may take a few seconds...')}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};